import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input
} from "reactstrap";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Redux
import { connect, useDispatch } from "react-redux";
import withRouter from 'components/Common/withRouter';

import { toast } from "react-toastify";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/user-4.jpg";

// actions
import { editProfile, resetProfileFlag } from "../../store/actions";

const UserProfile = props => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  const [email, setemail] = useState(authUser.email);
  const [name, setname] = useState(authUser.user_name);
  const [mobile, setmobile] = useState(authUser.phone_code + " " + authUser.mobno);
  const [mobno, setMobno] = useState(authUser.mobno);
  const [phone_code, setPhoneCode] = useState(authUser.phone_code);
  const [id, setidx] = useState(authUser.user_id);
  const [image, setimage] = useState(authUser.profile_pic);

  useEffect(() => {
    setTimeout(() => {
      props.resetProfileFlag();
    }, 3000);

    if (props.error || props.success) {
      setLoading(false);
    }

    if (props.error) {
      toast.error(props.error, {
        position: "top-right",
        autoClose: 3000,
      });
    }

    if (props.success) {
      toast.success(props.success, {
        position: "top-right",
        autoClose: 3000,
      });

      setemail(authUser.email);
      setname(authUser.user_name);
      setmobile(authUser.phone_code + " " + authUser.mobno);
    }
  }, [props.success, props.error]);


  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: name || '',
      email: email || '',
      id: id || '',
      mobno: mobno || '',
      phone_code: phone_code || '+218',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your User Name"),
      email: Yup.string().required("Please Enter Your Email Address"),
      phone_code: Yup.string().required("Phone code is required"),
      mobno: Yup.string().required("Mobile number is required"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      dispatch(editProfile(values));
    }
  });

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageLoading(true);

    const previewUrl = URL.createObjectURL(file);
    setimage(previewUrl);

    const formData = new FormData();
    formData.append("profile_image", file);

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/upload-image`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.status == 200) {
        setImageLoading(false);
        const data = await response.json();
        localStorage.setItem("authUser", JSON.stringify(data?.data));
        setimage(data?.data?.profile_pic);
        toast.success("Profile image updated successfully!");
      } else {
        setImageLoading(false);
        toast.error(response.data?.error || "Image upload failed!");
      }

    } catch (error) {
      setImageLoading(false);
      toast.error("Something went wrong!");
      console.error("Upload error:", error);
    }
  };

  document.title = "Profile | Moeen";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Home" breadcrumbItem="Profile" />

          <Row>
            <Col lg="4">
              <h4 className="card-title mb-4">Profile Detials</h4>
              <Card>
                <CardBody>
                  <div className="text-center">
                    <div className="position-relative d-inline-block mx-3">
                      {imageLoading ? (
                        <div
                          className="rounded-circle img-thumbnail d-flex align-items-center justify-content-center"
                          style={{
                            width: "150px",
                            height: "150px",
                            backgroundColor: "#e0e0e0",
                            animation: "pulse 1.5s infinite",
                            position: "relative",
                            zIndex: 1,
                          }}
                        >
                          <i className="fas fa-spinner fa-spin fa-2x text-muted"></i>
                        </div>
                      ) : (
                        <img
                          src={image ?? avatar}
                          alt="Profile"
                          className="avatar-md rounded-circle img-thumbnail"
                          style={{ objectFit: 'cover', width: '150px', height: '150px' }}
                        />
                      )}

                      {/* Camera icon overlay */}
                      {imageLoading ? (
                        <></>
                      ) : (
                        <label
                          htmlFor="upload-profile-image"
                          className="position-absolute"
                          style={{
                            bottom: "0",
                            right: "0",
                            cursor: "pointer"
                          }}
                        >
                          <i className="ti-camera bg-success" style={{ color: "#fff", fontSize: "17px", borderRadius: "50%", padding: "13px", fontWeight: "600" }}></i>
                          <input
                            id="upload-profile-image"
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleImageUpload}
                          />
                        </label>
                      )}
                    </div>
                    <div className="align-self-center mt-3 flex-1">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-1">{mobile}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="8">
              <h4 className="card-title mb-4">Update Detials</h4>

              <Card>
                <CardBody>

                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Input name="id" value={id} type="hidden" />
                    <div className="form-group">
                      <Label className="form-label">User Name</Label>
                      <Input
                        name="username"
                        className="form-control"
                        placeholder="Enter User Name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        invalid={
                          validation.touched.username && validation.errors.username ? true : false
                        }
                      />
                      {validation.touched.username && validation.errors.username ? (
                        <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="form-group mt-3">
                      <Label className="form-label">Email Address</Label>
                      <Input
                        name="email"
                        className="form-control"
                        placeholder="Enter Email Address"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                      ) : null}
                    </div>
                    <FormGroup className="mt-3">
                      <Label className="form-label">Mobile Number</Label>

                      <PhoneInput
                        country={'ly'}
                        value={mobile}
                        onChange={(value, country) => {
                          
                          const dialCode = `+${country.dialCode}`;
                          let mobileOnly = value;
                          if (value.startsWith(dialCode)) {
                            mobileOnly = value.slice(dialCode.length);
                          }

                          validation.setFieldValue('phone_code', dialCode);
                          validation.setFieldValue('mobno', mobileOnly);
                        }}
                        inputProps={{
                          name: 'mobno',
                          required: true,
                          className: 'form-control',
                          onBlur: validation.handleBlur,
                        }}
                        inputStyle={{ width: '100%' }}
                        containerStyle={{ width: '100%' }}
                        specialLabel={false}
                      />

                      {validation.touched.mobno && validation.errors.mobno ? (
                        <FormFeedback type="invalid" style={{ display: 'block' }}>
                          {validation.errors.mobno}
                        </FormFeedback>
                      ) : null}
                    </FormGroup>
                    <div className="text-center mt-4">
                      <Button type="submit" color="success" disabled={loading}>
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm" role="status" />
                          </>
                        ) : (
                          "Update Profile Details"
                        )}
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, { editProfile, resetProfileFlag })(UserProfile)
);
